export const VideoPlayer = ({ video, autoplay = true, muted = false, onEnded, startAt = 0 }) => {
  if (!video) return (
    <div className="aspect-video w-full bg-[color:var(--bg-elev)] grid place-items-center text-[color:var(--text-muted)]">
      Aucune vidéo sélectionnée
    </div>
  );
  // Build full URL for MP4 files served by backend
  const mp4Src = video.source_url?.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${video.source_url}`
    : video.source_url;
  const start = Math.max(0, Math.floor(startAt || 0));
  if (video.source_type === "youtube" && video.youtube_id) {
    const src = `https://www.youtube.com/embed/${video.youtube_id}?autoplay=${autoplay ? 1 : 0}&mute=${muted ? 1 : 0}&rel=0&modestbranding=1${start ? `&start=${start}` : ""}`;
    return (
      <div className="aspect-video w-full bg-black">
        <iframe
          key={video.id + String(muted)}
          data-testid="video-iframe"
          className="w-full h-full"
          src={src}
          title={video.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="aspect-video w-full bg-black">
      <video
        key={video.id}
        data-testid="video-mp4"
        className="w-full h-full"
        src={mp4Src}
        poster={video.thumbnail}
        autoPlay={autoplay}
        muted={muted}
        controls
        onEnded={onEnded}
        onLoadedMetadata={(e) => { if (start && e.target.duration > start) e.target.currentTime = start; }}
      />
    </div>
  );
};
